import { useState } from "react";
import { getHrefByType } from "@/utils/helper.util";
import { useTranslation } from "react-i18next";

import Button from "@/components/atoms/Button";
import CompanyDetailMoreData, {
  CompanyDetailLinkAsync,
} from "@/components/molecules/company/detail/overview/basic/CompanyDetailMoreData";
import Modal from "@/components/molecules/Modal";

type CompanyDetailLinksProps = {
  links: string[] | undefined;
  count: number;
} & CompanyDetailLinkAsync;

const CompanyDetailLinks = ({
  links,
  count,
  linkType = "website",
  infiniteQuery,
  heading,
  featuredIcon,
  placeholder,
}: CompanyDetailLinksProps) => {
  const { t } = useTranslation();
  const [moreIsShown, setMoreIsShown] = useState(false);

  if (!links || links.length === 0)
    return <div className={"text-sm text-tertiary"}>{t("company.detail.nothingFound")}</div>;

  return (
    <div className={"grid"}>
      {links.map((link, index) => (
        <CompanyDetailLink key={link} href={link} type={linkType}>
          {link}
          {index < links.length - 1 && ", "}
        </CompanyDetailLink>
      ))}

      {count - 3 > 0 && (
        <div>
          <Button
            label={t("company.detail.showMore", { count: count - 3 })}
            variants={"textLight"}
            color={"natural"}
            size={"2xs"}
            className={"!px-0.5"}
            onClick={() => setMoreIsShown(true)}
          />

          <Modal
            onClose={() => setMoreIsShown(false)}
            isOpen={moreIsShown}
            content={CompanyDetailMoreData}
            contentProps={{ linkType, infiniteQuery, heading, featuredIcon, placeholder }}
          />
        </div>
      )}
    </div>
  );
};

type CompanyDetailLinkProps = {
  href: string;
  children: React.ReactNode;
  type: "website" | "phone" | "email";
};

export const CompanyDetailLink = ({ href = "website", children, type }: CompanyDetailLinkProps) => (
  <a
    href={getHrefByType(type, href)}
    className={"break-words text-sm text-link hover:underline"}
    target={"_blank"}
    rel={"noreferrer"}
  >
    {children}
  </a>
);

export default CompanyDetailLinks;
